import get from 'lodash/get';

/**
 * Transforms an array of changes into the batch payload format expected by the
 * binary option discretionary add-on batch update API
 * @param {Array<Object>} changes - Array of change objects from XTable7 with updated/original data
 * @returns {Object} Batch payload with accounts array
 */
export const transformBinaryOptionDiscretionaryAddOnBatch = (changes) => {
  const accounts = changes.map((change) => {
    const accountId =
      get(change, 'updated.accountId') || get(change, 'original.accountId');
    const discretionaryAddOn = get(change, 'updated.discretionaryAddOn');

    if (!accountId) {
      throw new Error('Missing account_id for update');
    }

    if (discretionaryAddOn < 0) {
      throw new Error('Discretionary Add-on must be 0 or greater');
    }

    return {
      account_id: accountId,
      discretionary_add_on: String(discretionaryAddOn),
    };
  });

  return { accounts };
};

// Future transforms can be added here as needed
// Example:
// export const transformOtherConfigChange = (change) => { ... };
